import {
  Button,
  SkeletonLoader,
  SmartTableColumn,
  SmartTableDataItem,
} from '@toggle/design-system';
import React from 'react';

import { SharedTable } from '../shared-table/SharedTable';
import styles from './SectionBase.module.scss';

export interface SectionBaseProps<T> {
  title: string;
  onExpand?: () => void;
  tableData?: SmartTableDataItem<T>[];
  tableColumns?: SmartTableColumn<T>[];
  isFetching: boolean;
  onRowClick?: (item: SmartTableDataItem<T>) => void;
}

export const SectionBase = <T extends {}>({
  title,
  tableData = [],
  tableColumns = [],
  onExpand,
  isFetching,
  onRowClick,
}: SectionBaseProps<T>) => {
  return (
    <div className={styles.root}>
      <div className={styles.headerWrapper}>
        <div className={styles.title}>{title}</div>
        <Button
          variant="tertiary"
          iconName="Expand"
          size="small"
          onClick={() => onExpand?.()}
        />
      </div>
      {isFetching ? (
        <div className={styles.loadingSkeletonWrapper}>
          <SkeletonLoader
            areas={[
              {
                styles: { width: '100%', height: '96px', borderRadius: '8px' },
              },
            ]}
          />
        </div>
      ) : (
        <SharedTable
          tableData={tableData}
          tableColumns={tableColumns}
          onRowClick={onRowClick}
        />
      )}
    </div>
  );
};
